@layer refine.base {
  :host {
    --_panel-bg: var(--popover-bg, var(--color-canvas));
    --_panel-blur: var(--popover-panel-blur, var(--blur-md));
    --_panel-border-color: var(--popover-border-color, var(--color-divider));
    --_panel-shadow: var(--popover-shadow, var(--shadow-xl));

    position: relative;
    display: inline-block;
  }

  .panel {
    position: fixed;

    /* Popover UA resets */
    inset: unset;
    box-sizing: border-box;
    min-width: var(--popover-min-width, 12rem);
    max-width: var(--popover-max-width, 24rem);
    max-height: var(--popover-max-height, min(70vh, 32rem));
    padding: 0;
    margin: 0;
    overflow: auto;
    word-break: auto-phrase;
    overflow-wrap: anywhere;
    background: var(--_panel-bg);
    border: var(--border) solid var(--_panel-border-color);
    border-radius: var(--rounded-lg);
    box-shadow: var(--_panel-shadow);

    /* Hidden by default */
    opacity: 0;
    backdrop-filter: blur(var(--_panel-blur));
    transform: scale(var(--overlay-enter-scale-dialog)) translateY(4px);
    transition:
      opacity var(--transition-fast),
      transform 200ms var(--ease-spring),
      display var(--transition-fast) allow-discrete,
      overlay var(--transition-fast) allow-discrete;
  }

  .panel[data-open] {
    display: block;
  }

  .panel:popover-open,
  .panel[data-open] {
    opacity: 1;
    transform: scale(1) translateY(0);

    @starting-style {
      opacity: 0;
      transform: scale(var(--overlay-enter-scale-dialog)) translateY(4px);
    }
  }
}
